var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.formData.project_type == 2 && _vm.formData.type.includes("2")) ||
    (_vm.formData.project_meeting &&
      _vm.formData.project_meeting.process_result === "1" &&
      _vm.formData.type.includes("2"))
    ? _c(
        "div",
        {
          staticClass: "sub-form-container",
          class: {
            "sub-form-disabled":
              _vm.isTaskFormDisabled("2") || _vm.isViewTaskDisabled("2"),
            "sub-form-editing": _vm.isEditingTask("2"),
          },
        },
        [
          _c("div", { staticClass: "sub-form-title" }, [_vm._v("投标信息")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "投标负责人",
                        prop: "items.bidding_support.person_charge_id",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { filterable: "", placeholder: "请选择" },
                          on: {
                            change: function ($event) {
                              return _vm.handlePersonChargeChange(
                                _vm.formData.items.bidding_support,
                                _vm.bidSupportPersonList
                              )
                            },
                          },
                          model: {
                            value:
                              _vm.formData.items.bidding_support
                                .person_charge_id,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData.items.bidding_support,
                                "person_charge_id",
                                $$v
                              )
                            },
                            expression:
                              "formData.items.bidding_support.person_charge_id",
                          },
                        },
                        _vm._l(_vm.bidSupportPersonList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "标书状态",
                        prop: "items.bidding_support.status",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.formData.items.bidding_support.status,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData.items.bidding_support,
                                "status",
                                $$v
                              )
                            },
                            expression: "formData.items.bidding_support.status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("标书制作中"),
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("标书制作完成"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.formData.items.bidding_support.status === "2"
            ? [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "投标文件",
                              prop: "items.bidding_support.bid_files",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { width: "500px" } },
                              [
                                _c("uploadFile", {
                                  ref: "bidFileUpload",
                                  attrs: {
                                    "file-list":
                                      _vm.formData.items.bidding_support
                                        .bid_files,
                                    limit: 9,
                                    multiple: true,
                                    disabled: _vm.isViewTaskDisabled("2"),
                                    "current-file-count":
                                      _vm.formData.items.bidding_support
                                        .bid_files.length,
                                    source: "file",
                                    "only-img": false,
                                    "link-url": {
                                      config:
                                        "/user/project-delivery-file/upload/config",
                                      extensions:
                                        "/user/project-delivery-file/upload/file-allow-extensions",
                                    },
                                  },
                                  on: {
                                    emitUploadFile: _vm.handleBidFileUploaded,
                                    handleRemove: _vm.handleBidFileRemoved,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm.formData.items.bidding_support.bid_files.length
                              ? _c(
                                  "div",
                                  { staticClass: "file-list" },
                                  _vm._l(
                                    _vm.formData.items.bidding_support
                                      .bid_files,
                                    function (item, idx) {
                                      return _c(
                                        "div",
                                        { key: idx, staticClass: "file-item" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "file-name",
                                              class: {
                                                "pdf-file": _vm.isPdfFile(item),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.isPdfFile(item) &&
                                                    _vm.openPdfFile(item)
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(item.file_name))]
                                          ),
                                          !_vm.isViewTaskDisabled("2")
                                            ? _c("el-button", {
                                                staticClass:
                                                  "project-info-action",
                                                attrs: {
                                                  type: "text",
                                                  icon: "el-icon-delete",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteBidFile(
                                                      idx
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _c("el-button", {
                                            attrs: {
                                              type: "text",
                                              icon: "el-icon-download",
                                              disabled: false,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.downProjectFile(
                                                  item.url,
                                                  item.file_name
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "是否检查",
                              prop: "items.bidding_support.is_check",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.formData.items.bidding_support.is_check,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.bidding_support,
                                      "is_check",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.items.bidding_support.is_check",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("是"),
                                ]),
                                _c("el-radio", { attrs: { label: "2" } }, [
                                  _vm._v("否"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.formData.items.bidding_support.is_check === "1"
                      ? _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "检查人",
                                  prop: "items.bidding_support.check_person_id",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "value-key": "id",
                                      filterable: "",
                                      placeholder: "请选择",
                                    },
                                    on: { change: _vm.handleCheckPersonChange },
                                    model: {
                                      value:
                                        _vm.formData.items.bidding_support
                                          .check_person_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData.items.bidding_support,
                                          "check_person_id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.items.bidding_support.check_person_id",
                                    },
                                  },
                                  _vm._l(
                                    _vm.bidSupportPersonList,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.showProjectInfoEditButton("2")
            ? _c("section-edit-actions", {
                attrs: {
                  editing: _vm.isEditingTask("2"),
                  loading: _vm.editSaving,
                },
                on: {
                  start: function ($event) {
                    return _vm.startProjectInfoEdit("2")
                  },
                  confirm: _vm.confirmProjectInfoEdit,
                  cancel: _vm.cancelProjectInfoEdit,
                },
              })
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }